import React from 'react';
import classNames from 'classnames';
import * as CheckboxLib from '@radix-ui/react-checkbox';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

interface CheckboxProps extends CheckboxLib.CheckboxProps {
  id: string;
  label: string;
  classNameLabel?: React.HTMLAttributes<HTMLDivElement>['className'];
  classNameCheckbox?: React.HTMLAttributes<HTMLDivElement>['className'];
}

export function Checkbox({
  id,
  label,
  classNameLabel,
  classNameCheckbox,
  ...props
}: CheckboxProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
      }}
    >
      <CheckboxLib.Root
        className={classNames(classNameCheckbox, styles.CheckboxRoot)}
        id={id}
        {...props}
      >
        <CheckboxLib.Indicator className={styles.CheckboxIndicator}>
          <FontAwesomeIcon icon={faCheck} />
        </CheckboxLib.Indicator>
      </CheckboxLib.Root>
      <label className={classNames(classNameLabel, styles.Label)} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
